import Vue from 'vue';
import {
 getEventActivityMemberList, getActivityDropdown
} from '../../../services/eventActivityService/sicService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  eventActivityMemberList: [],
  storeTimeList: [],
  activityDropdown: [],
  pagination: {
    current_page: 0,
    per_page: 10
  },
  activityTimeList: [],
  editData: null,
  memberInfo: {},
};

// getters
const getters = {};

// actions
const actions = {
  // 取得event 活動資訊
  async getEventActivityMemberListHandler({ commit }, id) {
    const data = await getEventActivityMemberList(id);
    commit('setEventActivityMemberList', data);
  },
  // 取得活動下拉
  async getActivityDropdownHandler({ commit }, id) {
    const data = await getActivityDropdown(id);
    commit('setActivityDropdown', data.data);
  },
  // 取得預約時段
  async getActivityTimeListHandler({ commit }, id) {
    const data = await getActivityTimeList(id);
    commit('setActivityTimeList', data.data);
  },
  // 送出活動預約
  async sendEventActivityHandler({ commit }, formData) {
    return await sendEventActivity(formData);
  },
  // 取消預約
  async cancelEventActivityHandler({ commit }, formData) {
    return await cancelEventActivity(formData);
  },
  // 取得顧客資訊
  async getMemberInfoHandler({ commit }, line_uuid) {
    const data = await getMemberInfo(line_uuid);
    commit('setMemberInfo', data);
  },
  // 取得編輯資料
  async getEditDataHandler({ commit }, line_uuid) {
    const data = await getEditData(line_uuid);
    commit('setEditData', data.data);
  },
  // 編輯活動預約
  async editEventActivityHandler({ commit }, { id, input }) {
    const data = await editEventActivity({ id, input });
    commit('setEditData', data.data);
  }
};

// mutations
const mutations = {
  setEventActivityMemberList(state, data) {
    Vue.set(state, 'eventActivityMemberList', state.eventActivityMemberList.concat(data.data));
    Vue.set(state, 'pagination', data.pagination);
  },
  setActivityDropdown(state, data) {
    Vue.set(state, 'activityDropdown', data);
  },
  setActivityTimeList(state, data) {
    Vue.set(state, 'activityTimeList', data);
  },
  resetEventActivityMemberList(state) {
    Vue.set(state, 'eventActivityMemberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 10
    });
  },
  removeEventActivity(state, index) {
    state.eventActivityMemberList.splice(index, 1);
    Vue.set(state.pagination, 'total', state.pagination.total - 1);
  },
  updateEventActivity(state, { index, status }) {
    Vue.set(state.eventActivityMemberList[index], 'status', status);
  },
  setMemberInfo(state, data) {
    Vue.set(state, 'memberInfo', data);
  },
  setEditData(state, data) {
    Vue.set(state, 'editData', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
